import { icons, type LucideIcon, type LucideProps } from "lucide-react";
import { forwardRef } from "react";

export type IconProps = { name: keyof typeof icons } & LucideProps;

export const Icon = forwardRef<LucideIcon, IconProps>(
	({ name, ...props }, ref) => {
		const IconComponent = icons[name];

		// @ts-expect-error
		return <IconComponent ref={ref} {...props} />;
	},
);

Icon.displayName = "Icon";
